<div id="loading">
    <div class="dds__loading-indicator">
        <div class="dds__loading-indicator__spinner"></div>
      </div>
</div>